<template>
  <div class="vw100 bg-3 column a-center">
    <div class="w-per100 bdb-464646 column a-center">
      <div class="w-per62_5 h60 row a-center c-w ft16 font-Regular">
        <div class="flex1 h60 row flex-center pointer text-wrap text-center normal-break" v-for="(item,index) in navInfo.navList" :key="index" @click="changeNav(item,index)">{{ item.name }}</div>
      </div>
    </div>

    <div class="w-per100 column a-center pt30 pb35">
      <div class="w-per62_5 column a-center ft14 font-Regular lh30 c-w text-center">
        <div @click="toPath">Copyright © 2024 广东省广州市佰信纸业有限公司版权所有  网站备案号：{{ navInfo.icp }}  地址：{{ navInfo.address }}</div>
        <div>电话：{{ navInfo.tel }}邮箱：{{ navInfo.email }}   网址：{{ navInfo.web }}</div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      navInfo:'computedNav',
    })
  },
  mounted() {
    
  },
  methods: {
    // 跳转
    changeNav(item,index){
      // console.log(index);
      // 如果当前路由和点击的路由相同，不做任何操作
      if(this.$route.path == item.path){
        setTimeout(()=>{
          window.scrollTo({
            behavior: "smooth",
            top: 0,
          })
        },100)
        return ;
      }

      this.$router.push({
        path: item.path,
      })
    },
    // 备案
    toPath() {
      window.open('https://beian.miit.gov.cn', '_blank', 'noopener,noreferrer');
    },
  },
}
</script>

<style scoped lang="scss">

@media screen and (min-width: 750px) and (max-width: 1250px){

}
@media screen and (max-width: 750px){

}
</style>
